export const formatPhoneNumber = (phoneNumber: string): string => {
  const cleaned = phoneNumber.replace(/\D/g, '');
  if (cleaned.length !== 10) return phoneNumber;
  return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};
